module.exports = __webpack_public_path__ + "img/portrait-face.c7310489.svg";